import { Tooltip } from 'antd'
import { commaingNumber } from '../../utils'
import { exclametry_bg_gray_up } from '../../assets/images'
import { SALES_ROLE } from '../../constants/overview'

const invoiceSchema = ({ data, name, selectHandler, itemsSelected, history, start_date, end_date, invoice_id, dataLen = 0, isEntityCompany }) => {
  const bg_colors = {confirmed: '#E6F3F0', auto_confirmed: '#E6F3F0', rejected: '#FDEDEB', overdue: '#FDEDEB', approval_pending: '#FDF1E4', received: '#E6F3F0',}
  const text_colors = {confirmed: '#4B5563', auto_confirmed: '#4B5563', rejected: '#4B5563', overdue: '#4B5563', approval_pending: '#4B5563', received : '#4B5563'}
  const participation_text = {onsite: 'appointments', employee_addition: 'employees', doctor_consultation: 'employees', vaccination: 'vaccinations', }
  const invoice_status = (data.invoice_status || '').trim().toLowerCase().replace(/ /g, '_')
  const payment_status = (data.payment_status || '').trim().toLowerCase().replace(/ /g, '_')
  const service = (data.service || '').trim().toLowerCase().replace(/ /g, '_')
  
  return (
    <tr key={data.id} className='text-gray-600' style={{background: service === 'credit_note' ? '#FDF1E4':''}}>   
      { dataLen > 0 &&
        <td className='pl-3 pr-4 py-5' style={{width: '8%'}}>
          { !(service === 'credit_note') ?
            <input 
                  type='checkbox' 
                  onClick={(event) => selectHandler(event, data.company_invoice_item_id, name)} 
                  checked={itemsSelected.includes(data.company_invoice_item_id)} 
                  className='rounded-sm text-blue-600 h-5 w-5 border-gray-300 focus:ring-0 focus:ring-offset-0 cursor-pointer' 
            />
            : ''
          }
        </td>
      }
      <td className='pl-3 pr-4 py-5' style={{width: '17%'}}>
        <div>
          {data.service} {service === 'credit_note' && <Tooltip title='Credit amount available with ekincare' placement='right'><img src={exclametry_bg_gray_up} alt='exclametry-icon' className='inline ml-1 h-4 w-4' /></Tooltip>}
          {data.revised_invoice && <span className='rounded-2xl py-1 px-2 font-semibold text-gray-700 bg-blue-100'>Revised</span>}
        </div>
        {data.invoice_mode && 
          <span 
            className='py-1 px-2 rounded-2xl font-semibold text-xs' 
            style={{color: text_colors['approval_pending'], background: bg_colors['approval_pending']}}
          >
            {data.invoice_mode.trim()[0].toUpperCase() + data.invoice_mode.trim().slice(1)} invoice
          </span>
        }
      </td>
      {isEntityCompany && <td className='pl-3 pr-4 py-5' style={{width: '17%'}}>{data.entity_name} </td>}
      <td className={`pl-3 pr-4 py-5 font-semibold ${service === 'credit_note' ? 'text-green-1000':''}`} style={{width: '15%'}}>{service === 'credit_note' ? '- ':''}₹{commaingNumber(data.bill_amount)}</td>
      <td className='pl-3 pr-4 py-5' style={{width: '17%'}}>
        {data.participation_list ? 
          <span 
            onClick={() => history.push(`/invoices/${data.invoice_no}/participation-list`, {start_date, end_date, service: data.service, invoice_id, invoice_item_id: data.company_invoice_item_id})} 
            className={`font-semibold text-blue-500 ${!(SALES_ROLE === "sales") ? 'cursor-pointer' : 'pointer-events-none select-none' }`}
          >
            { service === 'engagement_activity' ? 'Participation list' : ( data.participation_list + " " + (participation_text[service] || data.service.trim().toLowerCase()) ) }
          </span> 
          : 'NA'
        }
      </td>
      <td className='pl-3 pr-4 py-5' style={{width: '13%'}}>
        { data.invoice_no ? <a href={data.pdf_url} target='_black' className={` font-semibold text-blue-500 hover:text-blue-500 ${!(SALES_ROLE === "sales") ? 'cursor-pointer' : 'pointer-events-none select-none' }`}>{data.invoice_no}</a> : 'NA'}
      </td>
      <td className='pl-3 pr-4 py-5' style={{width: '15%'}}>
        {data.invoice_status ? 
          <Tooltip overlayClassName='w-60' title='Invoice is auto confirmed as you have not confirmed the invoice by 06th of the month.' placement='bottom' trigger={invoice_status === 'auto_confirmed' ? 'hover' : 'none'}>
            <span className='rounded-2xl py-2 px-3 font-semibold whitespace-nowrap' style={{background: bg_colors[invoice_status], color: text_colors[invoice_status]}}>{data.invoice_status}</span> 
          </Tooltip>
          : 
          'NA'
        }</td>
      <td className='pl-3 pr-4 py-4 whitespace-nowrap' style={{width: '13%'}}>{data.payment_status ? <span className='rounded-2xl py-2 px-3 font-semibold' style={{background: (payment_status.includes('due') ? '#FDEDEB' : bg_colors[payment_status]), color: (payment_status.includes('due') ? '#4B5563'  : text_colors[payment_status]) }}>{data.payment_status}</span> : 'NA'}</td>
    </tr>
  )
}

export default invoiceSchema